import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { EnumPreferencesSection } from 'app/domains/aya/enums/preferences-section.enum';

@Injectable({
  providedIn: 'root',
})
export class PreferencesModalService {
  private isOpenSubject$ = new BehaviorSubject<boolean>(false);
  private activeSectionSubject$ = new BehaviorSubject<EnumPreferencesSection>(
    EnumPreferencesSection.Geral,
  );

  getIsOpen$(): Observable<boolean> {
    return this.isOpenSubject$.asObservable();
  }

  isOpen(): boolean {
    return this.isOpenSubject$.getValue();
  }

  getActiveSection$(): Observable<EnumPreferencesSection> {
    return this.activeSectionSubject$.asObservable();
  }

  activeSection(): EnumPreferencesSection {
    return this.activeSectionSubject$.getValue();
  }

  open(section?: EnumPreferencesSection): void {
    if (section) {
      this.activeSectionSubject$.next(section);
    }
    this.isOpenSubject$.next(true);
  }

  close(): void {
    this.isOpenSubject$.next(false);
  }

  closeAndReset(): void {
    this.isOpenSubject$.next(false);
    this.activeSectionSubject$.next(EnumPreferencesSection.Geral);
  }

  toggle(): void {
    this.isOpenSubject$.next(!this.isOpenSubject$.getValue());
  }

  setActiveSection(section: EnumPreferencesSection): void {
    this.activeSectionSubject$.next(section);
  }
}
